import React, { useState } from "react";
import "./ManagePartnersDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import bankicon from "../../../../assests/bankicon.svg";
import chargemap from "../../../../assests/chargemap.svg";
import gprofile from "../../../../assests/gprofile.svg";
import cohorts from "../../../../assests/cohorts.svg";
import uid from "../../../../assests/uid.svg";
import vmids from "../../../../assests/vmids.svg";
import { 
  Button, 
  Card, 
  CardContent, 
  Typography 
} from "@mui/material";

const ManagePartnersDetailsComponent = (props) => {
  const [showAll, setShowAll] = useState(false);
  const maxVisibleItems = 8;
  const { cohortId, franchiseeId } = useParams();
  const navigate = useNavigate();

  const machines = props.cohortDetails?.machines || [];
  const visibleMachines = machines.slice(0, maxVisibleItems);
  const remainingMachines = machines.slice(maxVisibleItems);

  // Function to get franchisee type display name
  const getFranchiseeTypeName = (cohortTypeId) => {
    const typeMapping = {
      2: "FOFO (Franchise)",
      4: "FOCO (City)",
      13: "PDF"
    };
    return typeMapping[cohortTypeId] || "N/A";
  };

  // Get franchisee type from cohortTypeId
  const franchiseeType = getFranchiseeTypeName(props.franchiseeDetails?.cohortTypeId);

  const handleGoBack = () => navigate(-1);
  const editCohortDetails = () => navigate(`/home/updatecohortdetails/${cohortId}`);
  const editFranchiseeDetails = () => navigate(`/home/updatefranchiseedetails/${franchiseeId}`);
  const editBankDetails = () => navigate(`/home/updatebankdetails/${franchiseeId}`);
  const editMapCharges = () => navigate(`/home/updatemapcharges/${franchiseeId}`);
  const addMapCharges = () => navigate(`/home/updatenewmapcharges/${franchiseeId}`);

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="manage-partners-container">
          <Sidebar />
          
          <div className="content-wrapper">
            <div className="header-section">
              <h2>
                <img 
                  src={leftArrow} 
                  alt="Back" 
                  className="back-arrow"
                  onClick={handleGoBack}
                />
                Manage Partners
              </h2>
            </div>

            {/* Cohort Details Section */}
            <div className="cohort-section">
              <div className="section-header">
                <div>
                  <img src={cohorts} alt="" /> 
                  Cohort Name: {props.cohortDetails?.name || "N/A"}
                </div>
                <Button variant="outlined" onClick={editCohortDetails}>
                  Edit
                </Button>
              </div>

              <div className="card-container">
                <div className="info-card">
                  <div className="info-group">
                    <span className="info-value">{props.cohortDetails?.areaName || "N/A"}</span>
                    <span className="info-label">Area Name</span>
                  </div>
                  <div className="location-info">
                    <p>Longitude: {props.cohortDetails?.lat || "N/A"}</p>
                    <p>Latitude: {props.cohortDetails?.lng || "N/A"}</p>
                  </div>
                </div>

                <div className="info-card wide-card">
                  <div className="info-row">
                    <img src={uid} alt="" />
                    <p>User ID: {props.cohortDetails?.id || "N/A"}</p>
                  </div>
                  <div className="info-row">
                    <img src={cohorts} alt="" />
                    <p>Cohort Type ID: {props.cohortDetails?.cohortTypeId || "N/A"}</p>
                  </div>
                  <div className="vm-ids-section">
                    <img src={vmids} alt="" />
                    <div className="vm-ids-container">
                      <p>VM ID's:
                        {visibleMachines.map((machine, index) => (
                          <span key={machine.id}>
                            {machine.id}
                            {index < visibleMachines.length - 1 ? ", " : ""}
                          </span>
                        ))}
                        {remainingMachines.length > 0 && (
                          <>
                            <span>...</span>
                            <button 
                              className="see-more-btn"
                              onClick={() => setShowAll(true)}
                            >
                              See More
                            </button>
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="info-card description-card">
                  <p>Description:</p>
                  <span>{props.cohortDetails?.description || "N/A"}</span>
                </div>
              </div>
            </div>

            {/* Franchisee and Bank Details Section */}
            <div className="details-section">
              <div className="franchisee-section">
                <div className="section-header">
                  <div>
                    <img src={gprofile} alt="" /> 
                    Franchise Name: {props.franchiseeDetails?.name || "N/A"}
                  </div>
                  <Button variant="outlined" onClick={editFranchiseeDetails}>
                    Edit
                  </Button>
                </div>

                <div className="franchisee-cards">
                  <div className="info-card">
                    <div className="info-group">
                      {/* Display franchisee type based on cohortTypeId */}
                      <span className="info-value">{franchiseeType}</span>
                      <span className="info-label">Franchise Type</span>
                    </div>
                    <div className="info-row">
                      <img src={cohorts} alt="" />
                      <p>Owner ID: {props.franchiseeDetails?.owner?.id || "N/A"}</p>
                    </div>
                    <div className="info-row">
                      <img src={uid} alt="" />
                      <p>Cohort ID: {props.franchiseeDetails?.cohortId || "N/A"}</p>
                    </div>
                    <div className="info-row">
                      <img src={uid} alt="" />
                      <p>Warehouse ID: {props.franchiseeDetails?.warehouse?.id || "N/A"}</p>
                    </div>
                  
                  </div>

                  <div className="info-card wide-card">
                    <p>Description:</p>
                    <span>{props.franchiseeDetails?.description || "N/A"}</span>
                  </div>
                </div>
              </div>

              <div className="bank-section">
                <div className="section-header">
                  <div>
                    <img src={bankicon} alt="" /> Bank Details
                  </div>
                  <Button variant="outlined" onClick={editBankDetails}>
                    Edit
                  </Button>
                </div>

                <div className="info-card bank-details-card">
                  <div className="info-row">
                    <p>Account Name: {props.franchiseeBankDetails?.accountName || "N/A"}</p>
                  </div>
                  <div className="info-row">
                    <p>Account ID: {props.franchiseeBankDetails?.accountId || "N/A"}</p>
                  </div>
                  <div className="info-row">
                    <p>IFSC Code: {props.franchiseeBankDetails?.ifsc || "N/A"}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Charges Section */}
            <div className="charges-section">
              <div className="section-header">
                <div>
                  <img src={chargemap} alt="" /> Charges
                </div>
                <div className="charge-buttons">
                  <Button variant="outlined" onClick={addMapCharges}>
                    Add charges
                  </Button>
                  <Button variant="outlined" onClick={editMapCharges}>
                    Remove charges
                  </Button>
                </div>
              </div>

              <div className="charges-container">
                {props.franchiseeCharges?.length > 0 ? (
                  props.franchiseeCharges.map((charge, index) => (
                    <Card key={index} className="charge-card">
                      <div className="charge-card-header">
                        <Typography>Charge Name {index + 1}</Typography>
                      </div>
                      <CardContent>
                        <ul className="charge-details">
                          <li>Id: {charge.id || "N/A"}</li>
                          <li>Name: {charge.name || "N/A"}</li>
                          <li>Description: {charge.description || "N/A"}</li>
                          <li>Beneficiary Type Id: {charge.beneficiaryTypeId || "N/A"}</li>
                          <li>Charge Type: {charge.chargeType || "N/A"}</li>
                          <li>Value Type: {charge.valueType || "N/A"}</li>
                          <li>Value: {charge.value || "N/A"}</li>
                          <li>Value Min: {charge.valueMin || "N/A"}</li>
                          <li>Value Max: {charge.valueMax || "N/A"}</li>
                        </ul>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <div className="no-charges">
                    <p>No charges added yet</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* See More Modal */}
          {showAll && (
            <div className="vm-modal">
              <div className="vm-modal-content">
                <h3>Remaining VM IDs</h3>
                <div className="vm-ids-list">
                  {remainingMachines.map((machine, index) => (
                    <span key={machine.id}>
                      {machine.id}
                      {index < remainingMachines.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </div>
                <button 
                  className="close-modal-btn"
                  onClick={() => setShowAll(false)}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ManagePartnersDetailsComponent;